/** Lead workspaces get Paid CPA instead of Paid ROAS, and no traffic charts. */
export const isLeadWorkspace = (template?: string | null) => template?.trim().toLowerCase() === 'lead';
